<template>
  <main-layout>
    <v-container fluid>
      <div class="mb-2 d-flex align-center">
        <div class="flex-grow-1">
          <v-text-field solo dense hide-details clearable :placeholder="$vuetify.lang.t('$vuetify.common.search')" prepend-inner-icon="mdi-magnify" v-model="search" />
        </div>
        <v-btn depressed tile class="ml-2" color="primary" @click="openUpdateForm()">
          <v-icon>mdi-plus</v-icon>
          {{$vuetify.lang.t('$vuetify.common.addUser')}}
        </v-btn>
      </div>
      <v-data-table dense
        height="calc(100vh - 212px)"
        :headers="headers"
        :items="items"
        :loading="loading"
        :options.sync="options"
        :footer-props="{'items-per-page-options': [20, 25, 30]}"
        :server-items-length="total">
        <template v-slot:[`item`]="{index, item}">
          <tr>
            <td class="text-center">{{indexOf(index)}}</td>
            <td class="text-center">{{item.user_id}}</td>
            <td class="text-center">{{item.user_name}}</td>
            <td class="text-center">
              {{$vuetify.lang.t(`$vuetify.tvsm.usertype.${item.user_type}`)}}
            </td>
            <td class="text-center">
              {{item.age}} / {{$vuetify.lang.t(`$vuetify.tvsm.gendershort.${item.gender}`)}} 
            </td>
            <td class="text-center">{{item.phone}}</td>
            <td class="text-center">{{item.email}}</td>
            <td class="text-center">
              <v-btn tile x-small depressed color="green darken-1" @click="openUpdateForm(item)">{{$vuetify.lang.t('$vuetify.common.update')}}</v-btn>
              <v-btn tile x-small depressed color="red" class="ml-1" @click="openDeleteConfirm(item)">{{$vuetify.lang.t('$vuetify.common.delete')}}</v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-container>

    <v-dialog persistent v-model="update.show" width="460">
      <v-card light v-if="update.form">
        <v-system-bar>FORM</v-system-bar>
        <v-card-text class="mt-4">
          <v-text-field :label="$vuetify.lang.t('$vuetify.common.ID')" hide-details outlined dense v-model="update.form.user_id" :readonly="!!update.form.id" />
          <v-text-field :label="$vuetify.lang.t('$vuetify.common.name')" hide-details outlined dense class="mt-3" v-model="update.form.user_name" />
          <v-select :label="$vuetify.lang.t('$vuetify.common.type')" outlined dense hide-details :items="update.userTypeOptions" class="mt-3" v-model="update.form.user_type" />
          <v-text-field :label="$vuetify.lang.t('$vuetify.common.age')" hide-details outlined dense class="mt-3" v-model="update.form.age" />
          <v-select :label="$vuetify.lang.t('$vuetify.common.sex')" outlined dense hide-details :items="update.genderOptions" class="mt-3" v-model="update.form.gender" />
          <v-text-field :label="$vuetify.lang.t('$vuetify.common.phone')" hide-details outlined dense class="mt-3" v-model="update.form.phone" />
          <v-text-field :label="$vuetify.lang.t('$vuetify.common.email')" hide-details outlined dense class="mt-3" v-model="update.form.email" />

        </v-card-text>
        <v-card-actions>
          <v-btn depressed tile class="flex-grow-1" color="primary" @click="closeUpdateForm()">{{$vuetify.lang.t('$vuetify.common.cancel')}}</v-btn>
          <v-btn depressed tile class="flex-grow-1" color="primary" @click="submitUpdateForm()">{{$vuetify.lang.t('$vuetify.common.submit')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </main-layout>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  methods: {
    indexOf (index) {
      const {page, itemsPerPage} = this.options
      return this.total - ((page - 1) * itemsPerPage + index)
    },
    async getItem () {
      const {sortBy, sortDesc, page, itemsPerPage} = this.options
      let q = {}
      if (sortBy.length) {
        q.order_by = []
        for (let i=0; i<sortBy.length; i++) {
          q.order_by.push({field: sortBy[i], direction: sortDesc[i] ? 'desc' : 'asc'})
        }
      }

      if (this.search) {
        let likestr = `%${this.search}%`
        q.filters = [{or: [
          {name: 'user_id', op: 'like', val: likestr},
          {name: 'user_name', op: 'like', val: likestr}
        ]}]
      }

      let params = { page, q: JSON.stringify(q), results_per_page: itemsPerPage }
      let {data} = await this.$http.get('users', {params})
      this.total = data.num_results
      this.items = data.objects
    },

    async openDeleteConfirm (item) {
      const {name, modal} = await this.$modal.open({
        text: `Delete "${item.user_id}"?`,
        actions: [
          {label: 'Cancel', name: 'cancel', color: 'primary'},
          {label: 'Submit', name: 'submit', color: 'primary'}
        ]
      })

      if (name === 'submit') {
        modal.loading = true
        await this.$http.delete(`users/${item.id}`)
        // modal.modal.text = ''
        this.getItem()
        modal.close()
      } 
      else modal.close()
    },
    openUpdateForm (item) {
      this.update.form = item ? Object.assign({}, item) : {}
      this.update.show = true
    },
    closeUpdateForm () {
      this.update.show = false
      this.update.form = null
      this.update.loading = false
    },
    async submitUpdateForm () {
      this.update.loading = true
      const {id, user_id, user_name, user_type, age, gender, phone, email} = this.update.form
      if (id) await this.$http.patch(`users/${id}`, {user_name, user_type, age, gender, phone, email})
      else await this.$http.post(`users`, {user_id, user_name, user_type, age, gender, phone, email})
      
      this.closeUpdateForm()
      const {modal} = await this.$modal.open({
        text: `Updated.`,
        actions: [
          {label: 'OK', name: 'submit', color: 'primary'}
        ]
      })
      modal.close()
      this.getItem()
    }
  },
  watch: {
    options: {
      handler () {
        this.getItem()
      },
      deep: true
    },
    search: debounce(function () {
      this.getItem()
    }, 350)
  },
  data () {
    return {
      loading: false,
      search: '',
      options: {},
      total: 0,
      headers: [
        { text: this.$vuetify.lang.t('$vuetify.tvsm.header.seq'), value: 'num', align: 'center', sortable: false, width: 80 },
        { text: this.$vuetify.lang.t('$vuetify.common.ID'), value: 'user_id', align: 'center' },
        { text: this.$vuetify.lang.t('$vuetify.common.name'), value: 'user_name', align: 'center' },
        { text: this.$vuetify.lang.t('$vuetify.common.type'), value: 'user_type', align: 'center' },
        { text: this.$vuetify.lang.t('$vuetify.tvsm.header.ageSexBloodType'), value: 'age', align: 'center' },
        { text: this.$vuetify.lang.t('$vuetify.common.phone'), value: 'phone', align: 'center', sortable: false },
        { text: this.$vuetify.lang.t('$vuetify.common.email'), value: 'email', align: 'center', sortable: false },
        { text: this.$vuetify.lang.t('$vuetify.common.editDelete'), value: 'edit', align: 'center', sortable: false, width: 140 }
      ],
      items: [],

      update: {
        show: false,
        loading: false,
        form: null,

        userTypeOptions: [
          {text: this.$vuetify.lang.t(`$vuetify.tvsm.usertype.1`), value: 1},
          {text: this.$vuetify.lang.t(`$vuetify.tvsm.usertype.2`), value: 2},
          {text: this.$vuetify.lang.t(`$vuetify.tvsm.usertype.3`), value: 3}
        ],
        genderOptions: [
          {text: this.$vuetify.lang.t(`$vuetify.tvsm.gender.1`), value: 1},
          {text: this.$vuetify.lang.t(`$vuetify.tvsm.gender.2`), value: 2}
        ]
      }
    }
  }
}
</script>